<template>
    <div class="score-container">
        <counter v-for="digit in digits" :ref="'counter' + name +'_' + (digit)" :id="name + '_' + (digit)" :key="name + '_' + (digit)" :small="small"></counter>
    </div>
</template>

<script>

/* eslint-disable */
import { mapGetters } from 'vuex';
import { eventBus } from '../main'

export default {
    props: ['name', 'digits', 'small', 'value'],
    data() {
        return {
        }
    },
    mounted() {
        if (this.value != undefined)
            this.jumpToNumber(this.value);
    },
    watch: {
        value(afterValue, beforeValue) {
            this.jumpToNumber(afterValue);
        }
    },
    methods: {
        jumpToNumber(number) {
            var stringNumber = number.toString();
            while (stringNumber.length < this.digits) 
                stringNumber = "0" + stringNumber;

            for (var i = 0; i < this.digits; i++)
            {
                var elementName = 'counter' + this.name + '_' + (i+1);
                this.$refs[elementName][0].jumpToNumber(+stringNumber.charAt(i));
            }
        }
    }
}    

</script>


// WEBPACK FOOTER //
// src/components/CounterContainer.vue